'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var cookieName = 'cookiesAccepted';
var defaultButtonText = 'That\'s ok with me';
var defaultNoticeText = 'Hello! Our website uses cookies to help us provide you with the best user experience and to ' + 'deliver customised experiences. You can find out more about the cookies we use and your cookie choices, ' + '<a href="https://pod-point.com/technical/privacy-policy" target="_blank">here</a>. ' + 'If you continue to use our services, we\'ll assume you\'re ok with this.';

/**
 * Sets the cookie accepting the terms.
 *
 * @param name
 */
var setCookie = function setCookie() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : cookieName;

    var date = new Date(new Date().setFullYear(new Date().getFullYear() + 10));
    document.cookie = name + '=1; path=/; expires=' + date.toUTCString();
};

/**
 * Checks if the terms cookie is present.
 *
 * @param name
 */
var hasCookie = function hasCookie() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : cookieName;
    return document.cookie.split('; ').reduce(function (previous, value) {
        var parts = value.split('=');
        return parts[0] === name ? true : previous;
    }, false);
};

/**
 * Remove the notice html element.
 *
 * @param noticeDiv
 */
var removeNotice = function removeNotice(noticeDiv) {
    noticeDiv.parentNode.removeChild(noticeDiv);
    setCookie(cookieName);
};

/**
 * Create the notice html element and append to the body tag.
 */
var showNotice = function showNotice(buttonText, noticeText) {
    var noticeDiv = document.createElement('div');
    noticeDiv.className = 'cookie-wrapper';

    var containerDiv = document.createElement('div');
    containerDiv.className = 'cookie-container';

    var rowDiv = document.createElement('div');
    rowDiv.className = 'cookie';

    var rowColMain = document.createElement('div');
    rowColMain.className = 'cookie__col cookie__col--grow';

    var rowColButton = document.createElement('div');
    rowColButton.className = 'cookie__col cookie__col--centre';

    var noticeButton = document.createElement('button');
    noticeButton.className = 'cookie__btn';
    noticeButton.innerHTML = buttonText || defaultButtonText;
    noticeButton.onclick = function () {
        return removeNotice(noticeDiv);
    };

    var noticeTextP = document.createElement('p');
    noticeTextP.className = 'cookie__notice';
    noticeTextP.innerHTML = noticeText || defaultNoticeText;

    rowColMain.appendChild(noticeTextP);
    noticeDiv.appendChild(containerDiv);
    containerDiv.appendChild(rowDiv);
    rowDiv.appendChild(rowColMain);
    rowDiv.appendChild(rowColButton);

    rowColButton.appendChild(noticeButton);
    document.body.appendChild(noticeDiv);
};

exports.default = {
    init: function init() {
        var buttonText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var noticeText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        if (!hasCookie(cookieName)) {
            showNotice(buttonText, noticeText);
        }
    },
    hasCookie: hasCookie,
    setCookie: setCookie
};
module.exports = exports['default'];